<template>
  <div>
    <v-flex p-t-30>
      <div class="tituloBox p-b-30 border-top">
        <div class="bg-primary barraTitulo"></div>
        <h1 class="text-info font-size-18">
          Qualificação
          <strong>Técnica</strong>
        </h1>
      </div>
    </v-flex>
  
    <div v-if="listaDocsExigidos.filter(e=>e.codDocumento != 166).length">
      <v-layout row wrap p-b-10>
        <v-flex>
          <fieldset>
            <legend>
              <strong class="text-primary">Documentos Exigíveis da Família</strong>
            </legend>
            <v-layout row wrap>
              <v-flex
                style=" max-width: 110px;"
                class="infoValidade"
                v-bind:class="{'fValida':validaDocExigivelPorFamilia(familia.idFamiliaFornec)}"
                font-weight-black
                v-for="familia in model.familiaSolicitacao"
                :key="familia.idFamiliaFornec"
              >
                {{familia.codGrupo+'.'+familia.numFamilia}}
                <v-icon>check</v-icon>
              </v-flex>
            </v-layout>
          </fieldset>
        </v-flex>
      </v-layout>

      <div class="boxFamilias">
        <v-layout row wrap class="p-t-10 p-b-20">
          <v-flex xs12>
            <v-card class="card--flex-toolbar">
              <v-toolbar light height="50px">
                <v-toolbar-title>
                  <strong>Documentos Exigíveis * (obrigatórios)</strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="openBox('exigidos')">
                  <v-icon color="primary">unfold_more</v-icon>
                </v-btn>
              </v-toolbar>
              <div v-show="isShow.exigidos">
                <v-flex
                  xs12
                  p-t-20
                  p-b-20
                  v-for="tipoDocumento in listaDocsExigidos"
                  :key="tipoDocumento.codGrupo+'_'+tipoDocumento.codDocumento"
                >
                  <fieldset vf>
                    <legend>
                      <strong class="text-primary">
                        {{tipoDocumento.nomDocumento}}
                      </strong>

                      <span class="text-primary" v-if="model.flagEstrangeiro == 1">
                          (OU DOCUMENTO EQUIVALENTE*)
                      </span>

                      <v-menu
                        v-model="info[tipoDocumento.codDocumento]"
                        :nudge-width="200"
                        offset-x
                      >
                        <template slot="activator">
                          <v-icon color="primary" style="margin-top:-6px" light>info</v-icon>
                        </template>

                        <v-card class="boxInfoDoc">
                          <v-card-title class="pb-1">
                            <strong>Exigível para seguintes Famílias:</strong>
                          </v-card-title>

                          <v-list-tile-content
                            v-for="e in infoListaDoc(tipoDocumento)"
                            :key="'fe_'+e.codGrupo+'.'+e.numFamilia"
                          >
                            <v-flex xs12 pb-1>
                              <strong>{{e.codGrupo+'.'+e.numFamilia}}</strong>
                              - {{e.descFamilia}}
                            </v-flex>
                          </v-list-tile-content>

                        </v-card>
                      </v-menu>
                    </legend>

                    <v-layout wrap>
                      <v-tooltip v-show="isAlteracao" top>
                        <v-btn slot="activator" icon  @click="editarDocumentoExigido(tipoDocumento.codDocumento)" >
                          <v-icon color="grey">edit</v-icon>
                        </v-btn>
                        <span>Editar</span>
                      </v-tooltip>

                      <v-flex xs6 sm4 md2>
                        <v-text-field
                          v-if="tipoDocumento.codDocumento != 109"
                          v-model="tipoDocumento.numDocumento"
                          :label="$t('label.numeroDocumento')+ ' *'"
                          :rules="validaIfObrigatorio(true)"
                          required
                          :readonly="validaReadonlyExigido(tipoDocumento.codDocumento)"
                          validate-on-blur
                          maxlength="30"
                          @change="removeAprovacaoRejeicao(tipoDocumento)"
                        ></v-text-field>
                      </v-flex>           
                              
                        <v-flex xs7 sm5 md3 v-if="tipoDocumento.nomDocumento != 'CARTA PATENTE SUSEP'">      
                        <datePicker
                          v-if="tipoDocumento.codDocumento != 109 && tipoDocumento.codDocumento != 51 && tipoDocumento.codDocumento != 127"
                          v-model="tipoDocumento.dtVencimento"
                          :dataDefault="tipoDocumento.dtVencimento"
                          v-mask="maskData"
                          :key="dtVencimentoKey"
                          :rules="(model.flagEstrangeiro === '0' ) ? validacao.campoObrigatorio.concat([v=>v.length==10 || 'Data Inválida']) : [] "
                          :label="$t('label.dataValidade')+' *'"
                          required
                          validate-on-blur
                          :bloquearData="validaReadonlyExigido(tipoDocumento.codDocumento)"
                          :testarDataVencida="validaDataVencida(tipoDocumento.dtVencimento)"
                          @change="removeAprovacaoRejeicao(tipoDocumento)"
                        />
                      </v-flex>
                      
                      <v-flex xs12 sm2 md2>
                        <v-text-field
                          v-model="tipoDocumento.codControle"
                          :readonly="validaReadonlyExigido(tipoDocumento.codDocumento)"
                          :label="$t('label.codDeControle')"
                          maxlength="50"
                          @change="removeAprovacaoRejeicao(tipoDocumento)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex inputIcon xs10 sm10 md2 v-show="!tipoDocumento.file.novoUpload" v-bind:class="{'md2':isAlteracao,'md3':!isAlteracao}">
                        <v-text-field
                          :value="subStrUpload(tipoDocumento.arquivoUpload,tipoDocumento.nomDocumento)"
                          :label="$t('label.anexaDocumento')+ ' *'"
                          clearable
                          append-icon="get_app"
                          readonly
                          @click:append="baixarArquivo(tipoDocumento.arquivoUpload)"
                          @click:clear="tipoDocumento.file.novoUpload = true;tipoDocumento.arquivoUpload = null;editarDocumentoExigido(tipoDocumento.codDocumento)"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs2 sm2 v-if="tipoDocumento.file.novoUpload" v-bind:class="{'md4':isAlteracao,'md5':!isAlteracao}">
                        <uploadFile
                          tamanhoMaximo="20MB"
                          :required="(model.flagEstrangeiro === '0' ? tipoDocumento.file.novoUpload : false)"
                          :label="$t('label.anexaDocumento')+' *'"
                          v-model="tipoDocumento.file.arquivoUpload"
                          accept=".pdf, .PDF"
                        />
                      </v-flex>

                      <v-flex class="text-primary" v-if="model.flagEstrangeiro == 1">
                        *
                        <sub>
                          Conforme Lei nº 9.433/2005.
                        </sub>
                      </v-flex>

                    </v-layout>
                  </fieldset>
                </v-flex>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>
    
    <div v-if="listaDocsElegiveis.length">
      <v-layout row wrap p-b-10>
        <v-flex>
          <fieldset>
            <legend>
              <strong class="text-primary">Documentos Elegíveis da Família</strong>
            </legend>
            <v-layout row wrap>
              <v-flex
                style=" max-width: 110px;"
                class="infoValidade"
                v-bind:class="{'fValida':validaDocElegivelPorFamilia(familia.idFamiliaFornec)}"
                font-weight-black
                v-for="familia in model.familiaSolicitacao"
                :key="familia.idFamiliaFornec"
                v-show="varificaSeTemElegiveis(familia.idFamiliaFornec)"
              >
                {{familia.codGrupo+'.'+familia.numFamilia}}
                <v-icon>check</v-icon>
              </v-flex>
            </v-layout>
          </fieldset>
        </v-flex>
      </v-layout>

      <div class="boxFamilias">
        <v-layout row wrap class="p-t-10 p-b-20">
          <v-flex xs12>
            <v-card class="card--flex-toolbar">
              <v-toolbar light height="50px">
                <v-toolbar-title>
                  <strong>Documentos Elegíveis * (informe um documento por família)</strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="openBox('elegiveis')">
                  <v-icon color="primary">unfold_more</v-icon>
                </v-btn>
              </v-toolbar>
              <div v-show="isShow.elegiveis">
                <v-flex
                  xs12
                  p-t-20
                  p-b-20
                  v-for="tipoDocumento in listaDocsElegiveis"
                  :key="'Ele'-tipoDocumento.codGrupo+'_'+tipoDocumento.codDocumento"
                >
                  <fieldset>
                    <legend>
                      <strong class="text-primary">
                        {{tipoDocumento.nomDocumento}}
                      </strong>
                      <span class="text-primary" v-if="model.flagEstrangeiro == 1">
                          (OU DOCUMENTO EQUIVALENTE*)
                      </span>

                      <v-menu
                        v-model="info[tipoDocumento.codDocumento]"
                        :nudge-width="200"
                        offset-x
                      >
                        <template slot="activator">
                          <v-icon color="primary" style="margin-top:-6px" light>info</v-icon>
                        </template>

                        <v-card class="boxInfoDoc">
                          <v-card-title class="pb-1">
                            <strong>Elegíveis para seguintes Famílias:</strong>
                          </v-card-title>

                          <v-list-tile-content
                            v-for="e in infoListaDoc(tipoDocumento)"
                            :key="'fe_'+e.codGrupo+'.'+e.numFamilia"
                          >
                            <v-flex xs12 pb-1>
                              <strong>{{e.codGrupo+'.'+e.numFamilia}}</strong>
                              - {{e.descFamilia}}
                            </v-flex>
                          </v-list-tile-content>

                        </v-card>
                      </v-menu>
                    </legend>

                    <v-layout wrap>

                       <v-tooltip v-show="isAlteracao" top>
                        <v-btn slot="activator" icon  @click="editarDocumentoElegivel(tipoDocumento.codDocumento)" >
                          <v-icon color="grey">edit</v-icon>
                        </v-btn>
                        <span>Editar</span>
                      </v-tooltip>

                      <v-flex xs6 sm4 md2>
                        <v-text-field
                          v-model="tipoDocumento.numDocumento"
                          :label="$t('label.numeroDocumento')"
                          :readonly="validaReadonlyElegivel(tipoDocumento.codDocumento)"
                          validate-on-blur
                          maxlength="30"
                          @change="removeAprovacaoRejeicao(tipoDocumento)"
                        ></v-text-field>
                      </v-flex>
                      
                      <!-- Apresenta campo de validade se documento for diferente de CARTA PATENTE SUSEP -->
                      <v-flex xs6 sm4 md3 v-if="tipoDocumento.nomDocumento != 'CARTA PATENTE SUSEP'">
                        <datePicker
                          v-model="tipoDocumento.dtVencimento"
                          :dataDefault="tipoDocumento.dtVencimento"
                          v-mask="maskData"
                          :label="$t('label.dataValidade') "
                          :key="dtVencimentoKey"
                          :bloquearData="validaReadonlyElegivel(tipoDocumento.codDocumento)"
                          :testarDataVencida="validaDataVencida(tipoDocumento.dtVencimento)"
                          @change="removeAprovacaoRejeicao(tipoDocumento)"
                        />
                      </v-flex>

                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="tipoDocumento.codControle"
                          :readonly="validaReadonlyElegivel(tipoDocumento.codDocumento)"
                          :label="$t('label.codDeControle')"
                          maxlength="50"
                          @change="removeAprovacaoRejeicao(tipoDocumento)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex inputIcon xs12 sm12 v-show="!tipoDocumento.file.novoUpload" v-bind:class="{'md3':isAlteracao,'md4':!isAlteracao}">
                        <v-text-field
                          :value="subStrUpload(tipoDocumento.arquivoUpload,tipoDocumento.nomDocumento)"
                          :label="$t('label.anexaDocumento')+ (ifBoxObrigatorio(tipoDocumento) ? ' *' : '')"
                          clearable
                          append-icon="get_app"
                          readonly
                          @click:append="baixarArquivo(tipoDocumento.arquivoUpload)"
                          @click:clear="tipoDocumento.file.novoUpload = true;tipoDocumento.arquivoUpload = null;editarDocumentoElegivel(tipoDocumento.codDocumento)"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs10 sm10  v-if="tipoDocumento.file.novoUpload" v-bind:class="{'md3':isAlteracao,'md4':!isAlteracao}">
                        <uploadFile
                          tamanhoMaximo="20MB"
                          :label="$t('label.anexaDocumento')"
                          v-model="tipoDocumento.file.arquivoUpload"
                          accept=".pdf, .PDF"
                        />
                      </v-flex>

                      <v-flex class="text-primary" v-if="model.flagEstrangeiro == 1">
                        *
                        <sub>
                          Conforme Lei nº 9.433/2005.
                        </sub>
                      </v-flex>

                    </v-layout>
                  </fieldset>
                </v-flex>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>
<script>
import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
export default {
  name: "qualificacaoTecnicaForm",
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    erroQualificacaoTecnica: Object,
    fornecedorQualificacaoTecnicaVm: Object,
    listaDocsQualificacaoTecnica: Object,
    OldModel: Object,
    isAlteracao: Boolean,
  },
  mixins: [util],
  watch: { //Propriedades assistidas
  },

  created() /*Metodo de start do componente*/{
    this.getListaDocsQualificacaoTecnica();
  },
  data() {//Declaracao de variaveis
    return {
      dtVencimentoKey:1,
      familiasValidadas: [],
      refreshcampo: [],
      info: [],
      arrayFamiliasDocumento: [],
      valid: true,
      isShow: { exigidos: true, elegiveis: true },
      listaDocsExigidos: [],
      listaDocsElegiveis: [],
      tableDoc: this.model.qualificacaoTecnica
    };
  },

  methods: {//Declaracao de todos os metodos

    validaDataVencida(data) {
      //valida data vencida
      return this.isAlteracao;
    },
    editarDocumentoExigido(codDocumento){
      //ediatar documento exigido
      if (this.isAlteracao)
      {
        //Limpar o documento
        this.listaDocsExigidos.find(x => x.codDocumento === codDocumento).numDocumento = null;
        this.listaDocsExigidos.find(x => x.codDocumento === codDocumento).dtVencimento = null;
        this.listaDocsExigidos.find(x => x.codDocumento === codDocumento).codControle = null;
        this.listaDocsExigidos.find(x => x.codDocumento === codDocumento).arquivoUpload =null;
        this.listaDocsExigidos.find(x => x.codDocumento === codDocumento).file.arquivoUpload = null;
        this.listaDocsExigidos.find(x => x.codDocumento === codDocumento).file.novoUpload = true;
        this.dtVencimentoKey++;
      }
    },

    validaReadonlyExigido(codDocumento){
      //validar se nao pode alterar o documento exigido
      var retorno = false;

      if (this.isAlteracao)
      {
        if (this.listaDocsExigidos.find(x => x.codDocumento === codDocumento).file.novoUpload === true)
        {
          return  false;
        }
        else
        {
          return  true;
        }
      }

      return retorno;


    },

    editarDocumentoElegivel(codDocumento){
      //limpar o documento para editar
      if (this.isAlteracao)
      {
        //Limpar o documento
        this.listaDocsElegiveis.find(x => x.codDocumento === codDocumento).numDocumento = null;
        this.listaDocsElegiveis.find(x => x.codDocumento === codDocumento).dtVencimento = null;
        this.listaDocsElegiveis.find(x => x.codDocumento === codDocumento).codControle = null;
        this.listaDocsElegiveis.find(x => x.codDocumento === codDocumento).arquivoUpload =null;
        this.listaDocsElegiveis.find(x => x.codDocumento === codDocumento).file.arquivoUpload = null;
        this.listaDocsElegiveis.find(x => x.codDocumento === codDocumento).file.novoUpload = true;
        this.dtVencimentoKey++;
      }
    },
    validaReadonlyElegivel(codDocumento){
      //verificar se pode alterar o documento elegivel
      var retorno = false;

      if (this.isAlteracao)
      {
        if (this.listaDocsElegiveis.find(x => x.codDocumento === codDocumento).file.novoUpload === true)
        {
          return  false;
        }
        else
        {
          return  true;
        }
      }

      return retorno;


    },

    validaDocExigivelPorFamilia(idFamiliaFornec) {
      //verificar se tem documento exigivel para familia
      var retorno = true;
      var docs = this.retornaDocPorIdFamilia(idFamiliaFornec);
      if (docs && docs.documentos) {
        docs.documentos.forEach(Dvalor => {
          var exigido = this.listaDocsExigidos.filter(
            e => e.codDocumento === Dvalor.codDocumento
          );
          if (exigido.length) {
            var todos = this.testePeloMenos1QualificacaoTecnica(exigido);
            if (!todos) {
              retorno = false;
            }
          }
        });
      }
      return retorno;
    },
    validaDocElegivelPorFamilia(idFamiliaFornec) {
      //verificar se foi cadastrado um documento elegivel para a familia
      var retorno = false;
      var docs = this.retornaDocPorIdFamilia(idFamiliaFornec);

      if (docs && docs.documentos) {
        docs.documentos.forEach(Dvalor => {
          var elegivel = this.listaDocsElegiveis.filter(
            e => e.codDocumento === Dvalor.codDocumento
          );

          var peloMenos1 = this.testePeloMenos1QualificacaoTecnica(elegivel);

          if (peloMenos1) {
            retorno = true;
          } else {
            var peloMenos1Exigivel = this.listaDocsExigidos.filter(
              x =>
                x.codDocumento === Dvalor.codDocumento && Dvalor.elegivel === "S"
            );

            peloMenos1Exigivel = this.testePeloMenos1QualificacaoTecnica(peloMenos1Exigivel);

            if (peloMenos1Exigivel) {
              retorno = true;
            }
          }
        });
      } else {
        retorno = true;
      }
      return retorno;
    },

    varificaSeTemElegiveis(idFamiliaFornec) {
      //verifica se tem documento elefivel para a familia
      var docs = this.retornaDocPorIdFamilia(idFamiliaFornec);
      var retorno = false;

      if (docs && docs.documentos) {
        docs.documentos.forEach(Dvalor => {
          var _elegivel = this.listaDocsElegiveis.find(
            e => e.codDocumento === Dvalor.codDocumento
          );
          if (_elegivel) retorno = true;
        });
      }

      return retorno;
    },
    retornaDocPorIdFamilia(idFamiliaFornec) {
      //retorna o documento de acordo com a familia
      return this.arrayFamiliasDocumento.find(
        x => x.idFamiliaFornec === idFamiliaFornec
      );
    },

    infoListaDoc(tipoDocumento) {
      //retorna uma lista de documento
      var lista = this.arrayFamiliasDocumento.filter(item => {
        if (
          item.documentos.find(
            x => x.codDocumento === tipoDocumento.codDocumento
          )
        )
          return true;
        else return false;
      });
      return lista;
    },
    getListaDocsQualificacaoTecnica() {
      this.fn_DocPorFamilia();
      this.listaExigidos();
      if(this.model.flagEstrangeiro === '1'){
        this.moveExigidosParaElegiveis();
      }
    },

    fn_DocPorFamilia() {
      //verifica documentos por familia
      this.arrayFamiliasDocumento = [];

      this.model.familiaSolicitacao.forEach(item => {
        this.arrayFamiliasDocumento.push({
          idFamiliaFornec: item.idFamiliaFornec,
          descFamilia: item.familiaAssociada.descFamilia,
          codGrupo: item.codGrupo,
          numFamilia: item.numFamilia,
          documentos: this.listaDocsQualificacaoTecnica.lista.filter(
            x => x.codGrupo === item.codGrupo && x.numFamilia === item.numFamilia
          )
        });
      });
    },

    listaExigidos() {
        var guarda = [];

        this.listaDocsExigidos = this.listaDocsQualificacaoTecnica.lista.filter(
          item => {
            // Atestado de capacidade técnica não é exibido na aba de Qualificação Técnica
            if (item.codDocumento === 109) return false;
            
            // 🆕 REGRA: Documento 180 só para Salvador/BA
            if (item.codDocumento === 180) {
              const ehSalvadorBA = this.model.codUf === "BA" && 
                                  this.model.endCidade && 
                                  this.model.endCidade.toUpperCase().trim() === "SALVADOR";
              if (!ehSalvadorBA) {
                return false; // Não exibe o documento 180 se não for Salvador/BA
              }
            }
            
            // Exigido somente se fizer parte de alguma familia
            if (this.arrayFamiliasDocumento.some(familia => familia.documentos.some(x => x.codDocumento === item.codDocumento)))
            {
              if (!guarda.find(x => x.codDocumento === item.codDocumento) && item.exigido === "S") 
              {
                guarda.push(item);
                return true;
              } else {
                return false;
              }
            }
          }
        );
        this.mergeListaQualificacaoFornecedor("exigidos");
        this.listaElegiveis();
      },

    listaElegiveis() {
      var guarda = [];
      this.listaDocsElegiveis = this.listaDocsQualificacaoTecnica.lista.filter(
        item => {
          // 🆕 REGRA: Documento 180 só para Salvador/BA
          if (item.codDocumento === 180) {
            const ehSalvadorBA = this.model.codUf === "BA" && 
                                this.model.endCidade && 
                                this.model.endCidade.toUpperCase().trim() === "SALVADOR";
                             
            if (!ehSalvadorBA) {
              return false; // Não exibe o documento 180 se não for Salvador/BA
            }
          }
          
          // Elegivel somente se fizer parte de alguma familia
          if (this.arrayFamiliasDocumento.some(familia => familia.documentos.some(x => x.codDocumento === item.codDocumento)))
          {
            if (!guarda.find(x => x.codDocumento === item.codDocumento) && 
              !this.listaDocsExigidos.find( x => x.codDocumento === item.codDocumento) &&
              item.elegivel === "S")
            {
              guarda.push(item);
              return true;
            } else {
              return false;
            }
          }
        }
      );
      this.mergeListaQualificacaoFornecedor("elegiveis");

      this.fornecedorQualificacaoTecnicaVm.lista = this.listaDocsExigidos.concat(
        this.listaDocsElegiveis
      );
    },
    mergeListaQualificacaoFornecedor(tipo) {
      //fazer um merge dos documentos cadastrados para a persistencia
      if (tipo === "exigidos") {
        this.listaDocsExigidos.forEach((item, chave) => {
          //Valor Da Tabela

          var dec = {
            idFornecSolicitacao: this.model.idFornecSolicitacao,
            numDocumento: null,
            dtVencimento: null,
            arquivoUpload: null,
            codDocumento: null,
            codControle: null,
            file: {
              arquivoUpload: null,
              novoUpload: true
            }
          };

          let tabelaDocFornec = this.tableDoc.find(
            x => x.codDocumento === item.codDocumento
          );

          if (tabelaDocFornec) {
            dec = this.preencherObjDaTabelaDocFornec(tabelaDocFornec);
          } else {
            dec.codDocumento = item.codDocumento;
          }
          item = Object.assign({}, item, dec);
          this.$set(this.listaDocsExigidos, chave, item);
        });
      }

      if (tipo === "elegiveis") {
        this.listaDocsElegiveis.forEach((item, chave) => {
          //Valor Da Tabela

          var dec = {
            idFornecSolicitacao: this.model.idFornecSolicitacao,
            numDocumento: null,
            dtVencimento: null,
            arquivoUpload: null,
            codDocumento: null,
            codControle: null,
            file: {
              arquivoUpload: null,
              novoUpload: true
            }
          };
          let tabelaDocFornec = this.tableDoc.find(
            x => x.codDocumento === item.codDocumento
          );

          if (tabelaDocFornec) {
            dec = this.preencherObjDaTabelaDocFornec(tabelaDocFornec);
          } else {
            dec.codDocumento = item.codDocumento;
          }
          item = Object.assign({}, item, dec);
          this.$set(this.listaDocsElegiveis, chave, item);
        });
      }
    },

    preencherObjDaTabelaDocFornec(tabelaDocFornec) {
      //preencher o objeto que vai ser mandado para persistencia no banco
      return {
        idFornecSolicitacao: this.model.idFornecSolicitacao,
        numDocumento: tabelaDocFornec.numDocumento,
        dtVencimento: tabelaDocFornec.dtVencimento,
        arquivoUpload: tabelaDocFornec.arquivoUpload,
        codDocumento: tabelaDocFornec.codDocumento,
        codControle: tabelaDocFornec.codControle,
        qualificacaoTecnicaSituacao: tabelaDocFornec.qualificacaoTecnicaSituacao,
        file: {
          arquivoUpload: null,
          novoUpload: tabelaDocFornec.arquivoUpload ? false : true
        }
      };
    },

    temDocumentos(idFamiliaFornec, codGrupo, numFamilia) {
      //verificar se tem documento para a familia
      var arr = this.arrayFamiliasDocumento.filter(
        f => f.idFamiliaFornec === idFamiliaFornec
      );
      if (arr.length) {
        arr = arr.filter(x =>
          x.documentos.find(
            d =>
              d.codGrupo === codGrupo &&
              d.numFamilia === numFamilia &&
              d.elegivel === "S"
          )
        );
      }
      if (arr.length) {
        return true;
      } else {
        return false;
      }
    },
    ifBoxObrigatorio(box) {
      //verificar se é obrigatorio
      var _box = [];

      _box.push(box);

      var peloMenos1CampoBox = (this.model.flagEstrangeiro === '1') ? true : this.testePeloMenos1CampoQualificacaoTecnica(_box);

      var validado = true;
      this.model.familiaSolicitacao.filter(familia => {
        if (this.varificaSeTemElegiveis(familia.idFamiliaFornec)) {
          if (!this.validaDocElegivelPorFamilia(familia.idFamiliaFornec)) {
            validado = false;
          }
        }
      });

      if (peloMenos1CampoBox || !validado) return true;
      else {
        return false;
      }
    },
    openBox(item) {
      //abrir o detalhe do documento
      this.isShow[item] = !this.isShow[item];
    },
    baixarArquivo(arquivo) {
      //baixar o documento
      const numCgcFornecedor = this.$verificaPerfilCadastrador()
        ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "")
        : null;
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },
    validaIfObrigatorio(validar) {
      //validar se é obrigatorio
      if(validar){
        if (this.model.flagEstrangeiro === '0' ) {
          return this.validacao.campoObrigatorio;
        } else {
          return [];
        }
      }else {
          return [];
      }
    },

    moveExigidosParaElegiveis(){
      this.listaDocsElegiveis = this.listaDocsElegiveis.concat(this.listaDocsExigidos);
      this.listaDocsExigidos = [];
    },





    removeAprovacaoRejeicao(tipoDocumento){
      this.fornecedorQualificacaoTecnicaVm.lista.forEach( (item) => {
        if(item.$id === tipoDocumento.$id){
          item.qualificacaoTecnicaSituacao = null;
          item.dtRejeicao = null;
          item.idMotivoIndeferimentoArquivo = null;
        }
      });
    }
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.infoValidade {
  opacity: 0.3;
}

.infoValidade.fValida {
  opacity: 1;
}

.infoValidade .v-icon {
  visibility: hidden;
}

.infoValidade.fValida .v-icon {
  color: #4caf50;
  visibility: visible;
}

.v-list__tile {
  height: 60px;
}

.v-list__tile__sub-title {
  font-size: 11px;
}

.v-list__tile--active {
  font-family: gothambold;
}

.v-list__tile--active .v-list__tile__title {
  color: #333;
}

.theme--light.v-subheader {
  font-family: gothambold;
  color: #10618b;
}

.tipoItem {
  padding-top: 0;
}
.boxFamilias .v-toolbar__title {
  font-size: 13px !important;
  color: #10618b;
}

.boxInfoDoc {
  font-size: 11px !important;
  color: #10618b;
}

.boxInfoDoc .v-card__title {
  font-size: 13px !important;
}


</style>
